export const PORTAL_ROUTE_NAMES = {
  DASHBOARD: 'inicio',
  PROFILE: 'perfil',
  PASSWORD: 'minha-senha',
  MY_CONTRACTS: 'meus-contratos',
  MY_EXTRACTS: 'meus-extratos',
  REPORT_ACCIDENTS: 'comunicar-sinistro',
  FREQUENTLY_ASKED_QUESTIONS: 'perguntas-frequentes',
  CONTACT_US: 'fale-conosco',
  REPORTS_PORTAL: 'portal-de-denuncias',
  TRACK_REQUESTS: 'acompanhar-solicitacoes',
  REGULATIONS: 'regulamentos',
};
